"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = exports.Header = exports.Separator = exports.ItemsWrapper = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
exports.ItemsWrapper = function (_a) {
    var smallItemsSpacing = _a.smallItemsSpacing, className = _a.className, children = _a.children, style = _a.style;
    return (react_1.default.createElement("div", { className: classnames_1.default({
            "gd-menu-wrapper": true,
            "gd-menu-wrapper-small-spacing": smallItemsSpacing,
        }, className), style: style }, children));
};
exports.ItemsWrapper.defaultProps = {
    smallItemsSpacing: false,
};
/**
 * @internal
 */
exports.Separator = function (props) { return (react_1.default.createElement("div", tslib_1.__assign({ className: "gd-list-item gd-list-item-separator" }, props))); };
/**
 * @internal
 */
exports.Header = function (_a) {
    var children = _a.children, restProps = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: "gd-list-item gd-list-item-header" }, restProps), children));
};
/**
 * @internal
 */
exports.Item = function (_a) {
    var checked = _a.checked, subMenu = _a.subMenu, disabled = _a.disabled, className = _a.className, children = _a.children, style = _a.style, onClick = _a.onClick;
    return (react_1.default.createElement("div", { className: classnames_1.default({
            "gd-list-item": true,
            "gd-menu-item": true,
            "is-checked": checked,
            "is-submenu": subMenu,
            "is-disabled": disabled,
        }, className), style: style, onClick: onClick }, children));
};
exports.Item.defaultProps = {
    checked: false,
    subMenu: false,
    disabled: false,
};
//# sourceMappingURL=MenuList.js.map